import styled from 'styled-components'

export const MenuWrapper = styled.div`
    a, svg {
        color: #9A9A9A;
    }
`;
